import Intro from './Intro';
import About from './About';
import MySkills from './MySkills';
import MyServices from './MyServices';
import MyProjects from './MyProjects';

function Home() {
  return (
    <>
      <Intro />
      <About />
      <MySkills />
      <MyServices />
      <MyProjects />
    </>
  );
}

export default Home;
